import React from 'react'
import { Link } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import BadgeUI from '../../../widgets/output/BadgeUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'

const PayableListUI = ({
  context, onRefreshClick, payable,
  onCopyToClipboard, copyToClipboardText,
  showDetails, onShowDetails, selectedRowId,
  paySubmitted, paySuccessMsg, payErrorList, onPayClick,
  deleteSubmitted, deleteSuccessMsg, deleteErrorList, onDeleteClick
}) =>
  <div className='txns'>
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Payment approvals</b></span>
        </div>
      }
      right={
        <div className='g_flex_h g_m_bottom_50'>
          <span>{payable.length} record{payable.length == 1 ? '' : 's'} displayed</span>
        </div>
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        payable.map((payables, i) =>
          <TxnRowUI key={i} context={context} payables={payables}
            onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
            showDetails={showDetails} onShowDetails={onShowDetails} selectedRowId={selectedRowId}
            paySubmitted={paySubmitted} paySuccessMsg={paySuccessMsg} payErrorList={payErrorList} onPayClick={onPayClick}
            deleteSubmitted={deleteSubmitted} deleteSuccessMsg={deleteSuccessMsg} deleteErrorList={deleteErrorList} onDeleteClick={onDeleteClick}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const TxnRowUI = ({ context, payables, onCopyToClipboard, copyToClipboardText,
  showDetails, onShowDetails, selectedRowId,
  paySubmitted, paySuccessMsg, payErrorList, onPayClick,
  deleteSubmitted, deleteSuccessMsg, deleteErrorList, onDeleteClick
}) =>
  <LRTableRowUI
    context={context}
    left={
      <RowLeftUI
        context={context}
        payables={payables}
        onCopyToClipboard={onCopyToClipboard}
        copyToClipboardText={copyToClipboardText}
        showDetails={showDetails}
        onShowDetails={onShowDetails}
        selectedRowId={selectedRowId}
      />
    }
    right={
      <RowRightUI
        context={context}
        payables={payables}
        paySubmitted={paySubmitted}
        paySuccessMsg={paySuccessMsg}
        payErrorList={payErrorList}
        onPayClick={onPayClick}
        deleteSubmitted={deleteSubmitted}
        deleteSuccessMsg={deleteSuccessMsg}
        deleteErrorList={deleteErrorList}
        onDeleteClick={onDeleteClick}
        selectedRowId={selectedRowId}
      />
    }
    className='g_flex_top'
  />

const RowLeftUI = ({ payables, onCopyToClipboard, copyToClipboardText, showDetails, onShowDetails, selectedRowId }) =>
  <div className='g_flex_v'>
    <span className=''>
      {payables.scheduledDateF}
      <span className='g_muted g_m_left_50'>{payables.payableId}</span>
      <span onClick={e => e.stopPropagation()}>
        <CopyToClipboard text={payables.payableId}
          onCopy={onCopyToClipboard}>
          <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
        </CopyToClipboard>
        {
          copyToClipboardText === payables.payableId &&
          <span className='g_m_left_50 g_muted'>copied</span>
        }
      </span>
    </span>
    {
      payables.payableType &&
      <span className='g_m_top_25'>
        <BadgeUI label={payables.payableType} />
        <BadgeUI className='g_m_left_25' label={payables.status} />
      </span>
    }
    <Link className='g_m_top_25' onClick={onShowDetails} to='#' data-row-id={payables.payableId}>
      Details
    </Link>
    {
      showDetails && selectedRowId === `${payables.payableId}` &&
      <>
        <span className='g_m_top_25'>
          <b>Message</b>
          <div dangerouslySetInnerHTML={{ __html: payables.message }} />
        </span>
        <span className='g_muted g_small g_m_top_25'>{payables.paymentRecord}</span>
      </>
    }
  </div>

const RowRightUI = ({ payables, selectedRowId,
  paySubmitted, paySuccessMsg, payErrorList, onPayClick,
  deleteSubmitted, deleteSuccessMsg, deleteErrorList, onDeleteClick,
}) =>
  <div className='g_flex_v g_text_right'>
    <span>{payables.amountF1}</span>
    {
      payables.status === 'unpaid' &&
      <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
        label='Approve' rowId={payables.payableId}
        onClick={onPayClick} alignLeft={false}
        busy={selectedRowId === payables.payableId && paySubmitted}
        successMsg={selectedRowId === payables.payableId && paySuccessMsg}
        errorList={selectedRowId === payables.payableId && payErrorList}
      />
    }
    {
      payables.status === 'unpaid' &&
      <ButtonTinyWithSpinnerUI className='g_m_top_25 g_text_right'
        label='Decline' rowId={payables.payableId}
        onClick={onDeleteClick} alignLeft={false}
        busy={selectedRowId === payables.payableId && deleteSubmitted}
        successMsg={selectedRowId === payables.payableId && deleteSuccessMsg}
        errorList={selectedRowId === payables.payableId && deleteErrorList}
      />
    }
  </div>

export default PayableListUI
